import gql from 'graphql-tag'
import { get } from 'lodash'
import { ITopicVersion } from '../../../../../types/TopicVersion'
import { apolloClientPrivate } from '../../../graphql/apolloClient'

export interface IVariables {
  topicId: number
  title: string
  summary: string
}

export interface IResponse {
  data: {
    topic: {
      id: number
      patchDraftVersion: {
        id: number
        updated_at: Date
      }
    }
  }
}

export type IOperationResult = Pick<ITopicVersion, 'id' | 'updated_at'>

/**
 * @deprecated
 */
export default async (variables: IVariables): Promise<IOperationResult> => {
  const mutation = gql`
    mutation workspace(
      $topicId: PositiveInt!
      $title: String
      $summary: String
    ) {
      topic(id: $topicId) {
        id
        ... on TopicModelAsEditor {
          patchDraftVersion(input: { title: $title, summary: $summary }) {
            id
            updated_at
          }
        }
      }
    }
  `

  const response = await apolloClientPrivate.mutate<IResponse>({
    variables,
    mutation
  })

  return get(response, 'data.topic.patchDraftVersion')
}
